import React from 'react'

import { AiOutlineTwitter } from "react-icons/ai"

import Girl from "../../../../assets/images/girl.png"

import "./Team.scss"

const Team = () => {
  return (
    <>
      <div className="team_container">
        <div className="box">
          <div className="heading">
            <div className="title">
              The team, the family
            </div>
            <div className="detail">
              We are 19 humans from the Sandaga startup but also from Smart-Chain (renowned Blockchain company in France) joining our forces to create The Metaverse Marauders and the Sandaga NFT Marketplace behind.
            </div>
          </div>
          <div className="data">
            <div className="mcard">
              <img src={Girl} alt="ERROR" />
              <div className="title"> Hélène SY </div>
              <div className="detail"> Co-founder, C.P.O. and Head of the Sandaga Education Program </div>
              <div className="social"> <AiOutlineTwitter /> </div>
            </div>
            <div className="mcard">
              <img src={Girl} alt="ERROR" />
              <div className="title"> Hélène SY </div>
              <div className="detail"> Co-founder, C.P.O. and Head of the Sandaga Education Program </div>
              <div className="social"> <AiOutlineTwitter /> </div>
            </div>
            <div className="mcard">
              <img src={Girl} alt="ERROR" />
              <div className="title"> Hélène SY </div>
              <div className="detail"> Co-founder, C.P.O. and Head of the Sandaga Education Program </div>
              <div className="social"> <AiOutlineTwitter /> </div>
            </div>
            <div className="mcard">
              <img src={Girl} alt="ERROR" />
              <div className="title"> Hélène SY </div>
              <div className="detail"> Co-founder, C.P.O. and Head of the Sandaga Education Program </div>
              <div className="social"> <AiOutlineTwitter /> </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Team
